import config from '../../config';
import { getAuthHeaders, handleResponse } from './common';

const stripeConnectApi = {
    getStatus: async () => {
        const res = await fetch(`${config.api.url}/stripe-connect/status`, {
            headers: getAuthHeaders()
        });
        return handleResponse(res);
    },

    onboard: async ({ returnUrl, refreshUrl } = {}) => {
        const body = {};
        if (returnUrl) body.returnUrl = returnUrl;
        if (refreshUrl) body.refreshUrl = refreshUrl;
        const res = await fetch(`${config.api.url}/stripe-connect/onboard`, {
            method: 'POST',
            headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        return handleResponse(res);
    },

    syncStatus: async () => {
        const res = await fetch(`${config.api.url}/stripe-connect/sync-status`, {
            method: 'POST',
            headers: getAuthHeaders()
        });
        return handleResponse(res);
    },

    getDashboardLink: async () => {
        const res = await fetch(`${config.api.url}/stripe-connect/dashboard-link`, {
            method: 'POST',
            headers: getAuthHeaders()
        });
        return handleResponse(res);
    }
};

export default stripeConnectApi;
